<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold {{ $t('select_connection', { connectionType }) }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    div.py-6.px-10
      .text-md.font-normal {{ $t('select_connection_description', { connectionType }) }}
      .my-4
        v-card.pa-4.round-lg.my-3(v-for="item in items" :key="item[item_id]" :class="item === selectedItem ? 'selected' : ''" outlined @click="selectedItem = item")
          .text-md {{ item[item_name] }}
          .text-sm.neutral500--text {{ item[item_id] }}
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="nextAction" :loading="isLoading" color="neutral700" :disabled="!canProceed" :dark="canProceed" depressed) {{ $t('next') }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReviewSelectionDialog',
  props: {
    open: {
      type: Boolean,
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    connectionType: {
      type: String,
      required: true,
      validator(value) {
        return ['location', 'account'].includes(value)
      }
    }
  },
  data() {
    return {
      isLoading: false,
      selectedItem: null
    }
  },
  computed: {
    ...mapGetters({
      gmbAccounts: 'review/getGmbAccounts'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    canProceed() {
      return this.selectedItem != null 
    },
    item_id() {
      return `${this.connectionType}_id`
    },
    item_name() {
      return `${this.connectionType}_name`
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    nextAction() {
      this.isLoading = true
      this.$emit('next', this.selectedItem)
    }
  },
}
</script>

<style scoped>
.v-card--link:before {
  background: none;
}
.selected {
  border-width: 2px;
  border-color: var(--v-info500)
}
</style>